export const convertTimestampToReadableFormat = (timestamp) => {
   const milliseconds = timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
   const date = new Date(milliseconds);
   return date.toLocaleString(); // This will convert the date to a human-readable format based on the user's locale
};
